<script>

import TableHandler from '../../../common/mixins/TableHandler'
import loading from '../../../common/components/loading'
import ValidationFilter from '../../clients/components/ValidationFilter.vue'

export default {
    name: 'TableClientGroups',

    components: {
        ValidationFilter,
        loading
    },

    mixins: [
        TableHandler
    ],

    data() {
        return {
            fields: [
                {
                    key: 'name',
                    label: 'Nom du groupe',
                    class: 'td-bold align-middle',
                    sortable: true
                },
                {
                    key: 'companies',
                    label: 'Sociétés liées',
                    sortable: false
                },
                {
                    key: 'id',
                    label: '',
                    sortable: false
                }
            ],
            unfilteredItems: []
        }
    },

    computed: {
        baseUrl() {
            return document.head.querySelector('meta[name="base-url"]').content
        }
    },

    async created() {
        this.filterable = false
        await this.getItems()
    },

    methods: {
        async getItems() {
            try {
                this.loading = true
                const response = await axios.get('/clientGroups')
                this.items = response.data.data
                this.updateTotalRows()
                this.loading = false
                await this.$store.dispatch('data/getAllOptions')
            } catch (error) {
                console.log(error)
                this.handleErrors(error.response)
            }
        },

        async deleteClientGroup(id) {
            try {
                await axios.delete('/clientGroups/' + id)
                await this.getItems()
            } catch (error) {
                //
            }
        },

        editClientGroup(id) {
            window.location.href = this.baseUrl + '/pilotage-activite/groupes/' + id + '/modification'
        }
    }
}
</script>

<template>
    <div>
        <div v-if="loading">
            <loading></loading>
        </div>

        <div v-else>
            <b-alert variant="danger" :show="hasErrors">
                <span v-html="errorMessage"></span>
            </b-alert>

            <!-- filter -->
            <b-row v-if="!hasErrors" class="mb-3">
                <b-col md="4" offset-md="8" class="my-1">
                    <b-form-group class="mb-0">
                        <b-input-group size="sm">
                            <b-form-input
                                v-model="filter"
                                placeholder="Entrer la valeur recherchée"
                            />
                            <b-input-group-append>
                                <b-button
                                    :disabled="!filter"
                                    @click="resetSearch"
                                >
                                    Effacer
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <!-- /filter -->

            <!-- Table -->
            <b-table
                responsive
                small
                :items="items"
                :fields="fields"
                :filter="filter"
                :per-page="perPage"
                :current-page="currentPage"
                @filtered="onFiltered"
            >
                <template #cell(name)="data">
                    <b-link @click="editClientGroup(data.item.id)">
                        {{ data.item.name }}
                    </b-link>
                </template>
                <template #cell(id)="data">
                    <b-link @click="deleteClientGroup(data.item.id)">
                        <i class="fas fa-fw fa-trash-alt text-danger"></i>
                    </b-link>
                </template>
            </b-table>
            <!-- /Table -->

            <!-- Pagination -->
            <b-row>
                <b-col md="3" class="my-1 text-center">
                    <b-pagination
                        v-if="totalRows > 0"
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                        class="my-0"
                        size="sm" />
                </b-col>
                <b-col md="6" class="my-2">
                    <p class="text-center small pt-0">{{ legend }}</p>
                </b-col>
                <b-col md="3" class="my-1 text-right">
                    <b-dropdown
                        right
                        split
                        size="sm"
                        :text="perPage + ' éléments par page'"
                    >
                        <b-dropdown-item
                            v-for="pageOption in pageOptions"
                            :key="pageOption"
                            @click="setPerPage(pageOption)"
                        >
                            {{ pageOption }}
                        </b-dropdown-item>
                    </b-dropdown>
                </b-col>
            </b-row>
            <!-- /Pagination -->
        </div>
    </div>
</template>

<style scoped>

</style>
